module.exports = __webpack_public_path__ + "assets/67a57dfd637b1711528e76a3c3b0dd84.png";